var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDataDictionary = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 92,
    viewBox: "0 0 70 92",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 16.1C70 5.5 52.4 0 35 0C17.6 0 0 5.5 0 16.1C0 16.2 0 16.3 0 16.4V16.5V76.4C0 86.6 17.6 92 35 92C52.4 92 70 86.6 70 76.3V16.5V16.4C70 16.2 70 16.2 70 16.1ZM62 46.4C62 48.6 52.5 54.1 35 54.1C17.5 54.1 8 48.7 8 46.4V26.7C14.8 30.3 24.9 32.2 35 32.2C45.1 32.2 55.2 30.3 62 26.7V46.4ZM35 8C52.8 8 62 13.7 62 16.1C62 18.5 52.8 24.2 35 24.2C17.2 24.2 8 18.5 8 16.1C8 13.7 17.2 8 35 8ZM35 84C17.5 84 8 78.6 8 76.3V56.7C14.8 60.2 24.9 62 35 62C45.1 62 55.2 60.2 62 56.7V76.3C62 78.6 52.5 84 35 84ZM52 42.9V38C52 36.1 53.6 34.5 55.5 34.5C57.4 34.5 59 36.1 59 38V42.9C59 44.8 57.4 46.4 55.5 46.4C53.6 46.4 52 44.9 52 42.9Z",
    fill: "#CDD4E4"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDataDictionary, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/data-dictionary.72c8e3bc.svg";
export { ForwardRef as ReactComponent };